import { type SendOfferFormData } from '@acme/domains';
import { Form, FormControls, useFormModel } from '@acme/foundation';
import { Button } from 'flowbite-react';
import { useMemo } from 'react';
import { sendOfferFormConfig } from './model';

export type SendOfferFormModalProps = {
  onConfirm: (data: SendOfferFormData) => void;
  onCancel?: () => void;
  isSubmitting?: boolean;
  inline?: boolean;
};

export const initialCtx: SendOfferFormData = {
  contractUniqueNumber: '',
  tradeAgreementNumber: '',
  files: [],
};

export const ApplicationSendOfferForm = ({
  onConfirm,
  onCancel,
  isSubmitting = false,
  inline = false,
}: SendOfferFormModalProps) => {
  const config = useMemo(() => sendOfferFormConfig(), []);
  const form = useFormModel<SendOfferFormData>({ config, ctx: initialCtx });

  const canSubmit =
    !isSubmitting &&
    !form.state.isSubmitting &&
    String(form.state.values.contractUniqueNumber ?? '').trim() !== '' &&
    String(form.state.values.tradeAgreementNumber ?? '').trim() !== '';

  return (
    <Form<SendOfferFormData>
      form={form}
      onSubmit={onConfirm}
      className="space-y-6"
    >
      <h3 className="text-xl font-semibold text-gray-900">Заполните данные</h3>

      <div
        className={
          inline ? 'grid grid-cols-1 sm:grid-cols-2 gap-4' : 'space-y-4'
        }
      >
        <FormControls
          form={form}
          filter={(cfg) =>
            cfg.id === 'contractUniqueNumber' ||
            cfg.id === 'tradeAgreementNumber'
          }
        />
      </div>

      <div className="space-y-2">
        <FormControls form={form} filter={(cfg) => cfg.id === 'files'} />
      </div>

      <div className="flex justify-end border-t border-gray-200 pt-4">
        <Button type="submit" color="primary" disabled={!canSubmit}>
          {isSubmitting || form.state.isSubmitting
            ? 'Отправка...'
            : 'Отправить предложение'}
        </Button>
        {!inline && onCancel ? (
          <Button
            type="button"
            color="light"
            onClick={onCancel}
            className="ml-2"
          >
            Отмена
          </Button>
        ) : null}
      </div>
    </Form>
  );
};
